import React, { useState, useEffect } from 'react'
import styleSelect from './Select.module.scss'

interface ISelectProps {
  value?: string | number
  label?: string
  isFixed?: boolean | false
  reference?: React.MutableRefObject<object>
  disabled?: boolean | false
  isFocus?: boolean | false
  isDashed?: boolean | false
  onChange?: (event: React.ChangeEvent<HTMLSelectElement>) => void
  isDefaultOption?: boolean
  options?: Array<{
    title: string
    value: string
  }>
}
export type SelectProps = ISelectProps

export const Select = (props: SelectProps): JSX.Element => {
  const [value, setValue] = useState(props.value ? String(props.value) : null)
  const [label] = useState(props.label ? props.label : null)
  const [isFocus, setIsFocus] = useState(props.isFocus ? props.isFocus : false)
  const [isFixed, setIsFixed] = useState(props.isFixed ? props.isFixed : false)
  const [options, setOptions] = useState(props.options ? props.options : null)
  const [isDefaultOption] = useState(
    typeof props.isDefaultOption === undefined ? true : props.isDefaultOption
  )

  useEffect(() => {
    setValue(props.value ? String(props.value) : null)
  }, [props.value])

  useEffect(() => {
    setIsFixed(props.isFixed ? props.isFixed : false)
    setOptions(props.options)

    return () => {
      setValue(null)
      setIsFixed(null)
      setOptions(null)
    }
  }, [props.isFixed, props.options])

  const [isDashed] = useState(
    props.isDashed ? props.isDashed : false
  )

  const classNameValueFocus = (value: string, isFocus: boolean, isFixed: boolean): string | null => {
    if (isFocus) {
      return styleSelect._field__box_value + ' ' + styleSelect._field__box_focused
    } else if (isFixed) {
      return styleSelect._field__box_value
    } else if (value) {
      return styleSelect._field__box_value
    }
    return null
  }

  const onChangeSelect = (event: React.ChangeEvent<HTMLSelectElement>): void => {
    setValue(event.target.value)
    if (props.onChange) {
      props.onChange(event)
    }
  }

  return (
    <div className={styleSelect._field}>
      <div
        className={
          styleSelect._field__box +
          (classNameValueFocus(value, isFocus, isFixed)
            ? ' ' + classNameValueFocus(value, isFocus, isFixed)
            : '') +
          (isDashed ? ' ' + styleSelect._field__box_dashed : '')
        }
      >
        <label>
          {label && (
            <span className={styleSelect._field__label}>
              {label}
            </span>
          )}
          <select
            className={styleSelect._field__select + ' ' + styleSelect._field__svg}
            onFocus={() => {
              setIsFocus(true)
            }}
            onBlur={() => {
              setIsFocus(false)
            }}
            autoComplete="off"
            defaultValue={value}
            ref={props.reference}
            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => { onChangeSelect(event) }}
          >
            {isDefaultOption && <option value={''}>Не выбрано</option>}
            {options?.map((option, index) => (
                <option value={String(option.value)} key={`option_${index}`}>
                  {option.title}
                </option>
            ))}
          </select>
        </label>
      </div>
    </div>
  )
}
